import BillerMerchantCodeEdit from './BillerMerchantCodeEdit';
import BillerMerchantCodeCreate from './BillerMerchantCodeCreate';
import BillerMerchantCodesList from './BillerMerchantCodesList';
import BillerMerchantCodeShow from './BillerMerchantCodeShow';

const resource = {
  list: BillerMerchantCodesList,
  edit: BillerMerchantCodeEdit,
  create: BillerMerchantCodeCreate,
  show: BillerMerchantCodeShow,
};

export default resource;
